import React from 'react';
import ReactDOM from 'react-dom';
import App from './';

const load = (element, props) =>
  element && ReactDOM.render(<App {...props} />, element);

window.inflLoader = window.inflLoader || {};
window.inflLoader = { ...window.inflLoader, loadProfileImageUploader: load };
